import { render } from "./CambiarGrupoModal.vue?vue&type=template&id=932b9c7c"
import script from "./CambiarGrupoModal.vue?vue&type=script&lang=js"
export * from "./CambiarGrupoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__